import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';
import { JwtPayload as OriginalJwtPayload } from 'jwt-decode';
import { environment } from '../../../environments/environment';

interface JwtPayload extends OriginalJwtPayload {
    [key: string]: string[] | string | number | undefined;
    permissions: string[];
  }

@Injectable({
  providedIn: 'root',
})
export class UserAccessService {
  constructor(private auth: AuthService) {}


  getUserRoles(): Observable<string[]> {
    return this.auth.getAccessTokenSilently().pipe(
      map((token) => {
        const decodedToken = jwtDecode<JwtPayload>(token);
        const roles = decodedToken[environment.auth.roleClaimType];

        // Ensure roles is always an array
        if (!roles) {
          return [];
        }
        if (!Array.isArray(roles)) {
          return [String(roles).toLowerCase()];
        }

        return roles.map(role => role.toLowerCase());
      }),
      catchError(() => {
        // Return empty roles - AuthGuard will handle redirect
        return of([]);
      })
    );
  }

  isAdmin(): Observable<boolean> {
    return this.getUserRoles().pipe(
      map(roles => roles.includes('admin'))
    );
  }

}
